






































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { CommonUtils } from '@/util/commonUtils';

@Component({})
export default class TermAndConditions extends Vue {
  private async mounted() {
    //
  }

  private logout() {
    CommonUtils.logout(this.$store.state);
  }
}
